import { useTranslation } from 'react-i18next';
import {
  FeaturesAuthAppleLoginButton,
  FeaturesAuthDevLoginForm,
  FeaturesAuthGoogleLoginButton,
  useLogin,
} from '@/features/auth';
import { env } from '@/shared/lib/env';

export const WidgetsLoginMain = () => {
  const { t } = useTranslation('login');
  const login = useLogin();
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gradient-to-b from-brand-50 to-surface-soft px-5 py-10">
      <div className="flex w-full max-w-md flex-col gap-6">
        <header className="flex flex-col items-center gap-3 text-center">
          <img
            src="/logo.jpg"
            alt="Tez Cargo"
            className="h-20 w-20 rounded-2xl object-contain shadow-elev"
          />
          <div>
            <h1 className="text-2xl font-bold text-ink">{env.appName}</h1>
            <p className="mt-1 text-sm text-ink-muted">{t('tagline')}</p>
          </div>
        </header>

        <section className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-5 shadow-card">
          <h2 className="text-base font-semibold text-ink-soft">{t('signIn')}</h2>
          <p className="text-sm text-ink-muted">{t('googlePrompt')}</p>
          <div className="mt-2">
            <FeaturesAuthGoogleLoginButton
              isLoading={login.isLoading}
              isInFlutter={login.isInFlutter}
              onIdToken={(token) => void login.loginWithGoogleIdToken(token)}
              onRequestNative={login.requestNativeLogin}
            />
            {login.isAppleAvailable && (
              <div className="mt-3">
                <FeaturesAuthAppleLoginButton
                  isLoading={login.isLoading}
                  onRequestNative={login.requestNativeAppleLogin}
                />
              </div>
            )}
          </div>
          {login.error && (
            <p role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
              {login.error}
            </p>
          )}
        </section>

        <FeaturesAuthDevLoginForm
          onSubmit={(access, refresh) => login.loginWithTokens(access, refresh)}
          disabled={login.isLoading}
        />

        <p className="text-center text-xs text-ink-faint">{t('terms')}</p>
      </div>
    </div>
  );
};
